define(
	'MHI.TrackingList.View',
	['SCView', 'mhi_tracking_list.tpl'],
	function(SCViewComponent, mhi_tracking_list) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function MyView(options) {
			SCView.call(this);

			this.options = options || {};
			

			this.template = mhi_tracking_list;

			this.attributes = { id: 'MyViewId', class: 'my-view' };

			
		}

		// Inherit parent instance methods.
		MyView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		MyView.prototype.constructor = MyView;

		MyView.prototype.getContext = function() {
			

			return {
				itemFulfillments:this.options.trackingList,
				isnotEmpty:this.options.trackingList.length > 0
			}
		}

		
	

		// Return the AMD constructor.
		return MyView;
	}
);
